// Single reader for event_staff_assignments.permissions.
// Stored shape is an object: { scoring: true, check_in: true }. Legacy arrays
// (["score_matches"], ["check_in"], ["all"]) are still accepted.

export type StaffPermissionFlags = { canScore: boolean; canCheckIn: boolean };

export function getStaffPermissions(
  assignment: { permissions?: any; role?: string | null } | null | undefined
): StaffPermissionFlags {
  const perms = assignment?.permissions;
  const role = String(assignment?.role ?? '').toLowerCase();

  if (Array.isArray(perms)) {
    const all = perms.includes('all');
    return {
      canScore: all || perms.includes('score_matches') || perms.includes('scoring') || role.includes('score'),
      canCheckIn: all || perms.includes('check_in'),
    };
  }

  const p = perms && typeof perms === 'object' ? perms : {};
  return {
    canScore: p.scoring === true || p.can_score === true || role.includes('score'),
    canCheckIn: p.check_in === true || p.can_check_in === true,
  };
}
